import { countDriverTickets } from '../ticketList/countDriverTickets';
import { shouldMachineBeRepaired } from './shouldMachineBeRepaired';

// frontend function
export const calculateTicketCount = (docket, tenantSettings) => {
	// check if should be repaired at all
	if (!docket.ticketList || !shouldMachineBeRepaired(docket.machineServiceType)) {
		return false;
	}

	const ticketCount = countDriverTickets(docket.ticketList.driverItems, tenantSettings);

	// quit if there's no tickets
	if (!ticketCount) {
		return false;
	}

	// Return count if any
	return ticketCount;
};
